import { Progress } from "@/components/ui/progress";

interface QuestionHeaderProps {
  title: string;
  current: number;
  total: number;
}

export function QuestionHeader({ title, current, total }: QuestionHeaderProps) {
  const percentage = total > 0 ? (current / total) * 100 : 0;

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h1 className="text-xl font-semibold">{title}</h1>
        <span className="text-sm text-muted-foreground">
          Question {current} of {total}
        </span>
      </div>
      <Progress value={percentage} className="h-2" />
    </div>
  );
}
